import React, { useState } from 'react';
import { Query } from 'react-apollo';
import { useHistory } from 'react-router-dom';
import { get, find } from 'lodash';

import {
   DropdownMenu,
   DropdownMenuButton,
   DropdownMenuItem,
   DropdownMenuItems,
} from '@jetshop/ui/DropdownMenu';

import { ReactComponent as Caret } from '../../../svg/Caret.svg';
import { ReactComponent as Check } from '../../../svg/Check.svg';

import productSiblingsQuery from './PropertiesSelectorQuery.gql';
import { Label } from '../../Forms/Input';

// Get color name from product name
const getColorName = name => {
   const productNameSplit = name?.split(' - ');
   const colorName = productNameSplit[productNameSplit?.length - 1];
   // Set first letter of color name uppercase
   const colorNameUpperCase =
      colorName?.charAt(0).toUpperCase() + colorName?.slice(1);
   return colorNameUpperCase;
};

const getSiblings = (results, series) => {
   // Only get products in the same series (search can retun all sorts of stuff)
   const filtered = get(results, 'data.search.products.result', []).filter(s =>
      s.articleNumber.startsWith(series),
   );

   // Add some metadata
   const withMeta = filtered.map(i => {
      const colorName = getColorName(i.name);

      const [series, color] = i.articleNumber.split('-');

      return { series, color, colorName, ...i };
   });

   return withMeta;
};

const PropertiesSelector = ({ product, className }) => {
   const history = useHistory();
   const { articleNumber } = product;
   const [series, color] = articleNumber.split('-');
   const [values, setValues] = useState({ color });

   // Parse artnumber
   if (!series) return null;

   return (
      <Query variables={{ searchTerm: series }} query={productSiblingsQuery}>
         {results => {
            // Keep in mind that the siblings also includes current product
            const siblings = getSiblings(results, series);
            const hasSiblings = siblings.length > 1;

            const colors = [];
            siblings.forEach(s => {
               if (s.color && colors.indexOf(s.color) === -1) {
                  colors.push({ id: s.color, name: s.colorName });
               }
            });

            const handleChange = (val, property) => {
               const toFind = {
                  color: values.color,
               };
               toFind[property] = val;

               // Update <select>s before reload
               setValues(toFind);

               const found = find(siblings, toFind);

               if (found?.articleNumber !== product.articleNumber) {
                  history.push(found?.primaryRoute?.canonicalPath);
               }
            };
            return hasSiblings ? (
               <div className={className}>
                  {colors.length > 0 && (
                     <>
                        <DropdownMenu>
                           <DropdownMenuButton id={values.color}>
                              {getColorName(product?.name)}

                              <Caret />
                           </DropdownMenuButton>
                           <DropdownMenuItems style={{ zIndex: 9999 }}>
                              {colors.map((val, i) => (
                                 <DropdownMenuItem
                                    key={i}
                                    onSelect={({ setIsOpen }) => {
                                       setIsOpen(false);
                                       handleChange(val.id, 'color');
                                    }}
                                    style={{ opacity: 1 }}
                                 >
                                    {val.name}
                                    {val.id === values.color && <Check />}
                                 </DropdownMenuItem>
                              ))}
                           </DropdownMenuItems>
                        </DropdownMenu>
                     </>
                  )}
               </div>
            ) : null;
         }}
      </Query>
   );
};

export default PropertiesSelector;
